import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import { history } from 'src/core/router'
import { isRtl } from 'src/helper/tool'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { lang, nav, language, setNav, redCount, rpIsShow } = this.props
    return (
      <div className={`nav navbg${nav} ${isRtl(language) && 'arlang'}`}>
        <div
          className={`navitem ${nav == 1 && 'active'}`}
          onClick={() => {
            setNav(1)
          }}
        >
          {lang.nav1}
        </div>

        {rpIsShow && (<div
          className={`navitem ${nav == 3 && 'active'}`}
          onClick={() => {
            setNav(3)
          }}
        >
          {lang.reportTxt}
        </div>)}

        <div
          className={`navitem ${nav == 2 && 'active'}`}
          onClick={() => {
            setNav(2)
          }}
        >
          {lang.nav2}
          {redCount > 0 && <div className={`${language == 'ar' && 'arlang'} red`} style={{ right: rpIsShow ? '28%' : '' }}>{redCount}</div>}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/Nav/index.js